module.exports = __webpack_public_path__ + "static/media/comment-info.7deb4450.svg";